"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findCandyMachineAuthorityPda = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
function findCandyMachineAuthorityPda(context, seeds) {
    const programId = context.programs.get('mplCandyMachineCore').publicKey;
    return context.eddsa.findPda(programId, [
        (0, serializers_1.string)({ size: 'variable' }).serialize('candy_machine'),
        (0, serializers_1.publicKey)().serialize(seeds.candyMachine),
    ]);
}
exports.findCandyMachineAuthorityPda = findCandyMachineAuthorityPda;
//# sourceMappingURL=candyMachineAuthority.js.map